export default __webpack_public_path__ + "static/media/FilmStrips.4a88106a.svg";